import React, { useState } from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

// Services
import SaveAppointment from '../services/appointment'

// Libs
import { toast } from 'react-toastify'

function ContactPage() {

  const [formData, setFormData] = useState({
    specialty: "",
    name: "",
    email: "",
    phone: "",
    comments: ""
  })

  const sendNotification = (type, text) => {
    switch (type) {
      case 'success':
        toast.success(text, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        break;
      case 'warning':
        toast.warn(text, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        break;
      case 'error':
        toast.error(text, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        break;
      default:
        break;
    }
  }

  const handleInputChange = event => {
    if (event) {
      const target = event.target
      const value = target.value
      const name = target.name
      console.log({ target, name, value })
      setFormData({
        ...formData,
        [name]: value,
      })
    }
  }

  const handleSubmit = async event => {
    event.preventDefault()
    const { name, email, phone, specialty } = formData
    console.log({ specialty })
    if (!name || !email || !phone || !specialty) {
      sendNotification('warning', '¡Oops! Parece que te falta llenar algnos datos.')
      return false
    }
    try {
      const { success } = await SaveAppointment({ ...formData })
      if (success)
        sendNotification('success', '¡Muchas gracias! Nuestro equipo se pondrá en contacto contigo.')
      else
        sendNotification('error', '¡Oops! Parece que hay un problema con nuestros servidores. Intenta más tarde.')
    } catch (e) {
      sendNotification('error', '¡Oops! Parece que hay un problema con nuestros servidores. Intenta más tarde.')
    }
  }

  return (
    <Layout>
      <SEO
        keywords={[`gatsby`, `tailwind`, `react`, `tailwindcss`]}
        title="Contact"
      />
      <section className="grid grid-cols-12 lg:pt-48 pt-75 bg-light_brown">
        <div className="lg:col-start-4 lg:col-span-6 col-start-2 col-span-10 mb-6 md:ml-5">
          <h4 className="text-2xl tracking-wider mt-10">RESERVA TU CITA</h4>
          <p className="text-lg font-light">Completa el formulario y nos pondremos en contacto contigo para confirmar tu cita.</p>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-12">
              <div className="col-span-12">
                <select className="py-3 px-4 rounded-md font-thin mt-6 w-full" defaultValue="1" onChange={handleInputChange} name="specialty">
                  <option value="1" disabled>Seleccione una specialidad</option>
                  <option value="dermatologia">Dematología</option>
                  <option value="medicina fotonica">Medicina Fotónica</option>
                  <option value="spa and sport">Span & Sport</option>
                  <option value="ginecologia">Ginecología</option>
                  <option value="cirugia plastica">Cirugía Plástica</option>
                  <option value="tratamientos esteticos">Tratamientos estéticos</option>
                  <option value="fotodermatologia">Fotodermatología</option>
                  <option value="medicina estetica">Medicina estética</option>
                </select>
              </div>
              <div className="col-span-12">
                <input
                  placeholder="Nombre completo"
                  name="name"
                  className="py-3 px-4 rounded-md font-thin mt-3 w-full"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-span-12">
                <input
                  placeholder="Correo electrónico"
                  name="email"
                  className="py-3 px-4 rounded-md font-thin mt-3 w-full"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-span-12">
                <input
                  placeholder="Teléfono"
                  name="phone"
                  className="py-3 px-4 rounded-md font-thin mt-3 w-full"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-span-12">
                <textarea
                  placeholder="Comentario"
                  name="comments"
                  className="py-3 px-4 rounded-md font-thin mt-3 w-full"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-span-12">
                <button type="submit" className="px-4 py-4 hover:bg-white hover:text-main_color bg-main_color w-full mt-6 rounded-sm tracking-wide text-white">ENVIAR</button>
              </div>
            </div>
          </form>
        </div>
      </section>
    </Layout>
  );
}

export default ContactPage;
